import './google_place.less';

import { MapPin }        from 'react-feather';
import { Star }          from 'react-feather';
import GoogleLogo        from './google_logo.svg';
import Link              from '../components/link';
import OnboardingSection from './onboarding_section';
import pluralize         from '../util/pluralize.js';
import React             from 'react';
import useCompleted      from './use_completed';


export default function GoogleSection({ googlePlace, reviews }) {
  const { isCollapsed, complete } = useCompleted('onboarding-google-place-confirmed', googlePlace.confirmed);

  return (
    <OnboardingSection className="google" collapsed={isCollapsed}>
      <h2>Confirm your Google listing</h2>
      <div className="not-completed-section">
        <p>
          To begin collecting reviews, we need to make sure we’ve got the right location for your business. Seeing the wrong location? <Link href="https://broadlyhelp.force.com/s/contactsupport" external>Send us the link to the right location.</Link>
        </p>
        <PlaceInfo {...{ googlePlace, reviews }}/>
        <Actions {...{ complete }}/>
      </div>
    </OnboardingSection>
  );
}


function PlaceInfo({ googlePlace, reviews }) {
  const name             = googlePlace.name;
  const address          = googlePlace.formatted_address;
  const phone            = googlePlace.formatted_phone_number;
  const googleReviewData = getGoogleReviewData(reviews);

  return (
    <div className="google-place">
      <GoogleLogo className="google-logo"/>
      <div className="place-info">
        <div className="place-name"><strong>{name}</strong></div>
        <div className="place-address">{address}</div>
        <div className="place-phone">{phone}</div>
      </div>
      <ReviewsInfo {...{ googleReviewData }}/>
    </div>
  );
}


function ReviewsInfo({ googleReviewData }) {
  const { rating }      = googleReviewData;
  const { reviewCount } = googleReviewData;
  const hasReviews      = reviewCount > 0;
  if (hasReviews) {
    return (
      <div className="review-info">
        <Stars rating={rating}/>
        <Statistics rating={rating} reviewCount={reviewCount}/>
      </div>
    );
  } else
    return null;
}

function Stars({ rating }) {
  const percentage = (rating / 5) * 100;
  const style      = {
    width: `${percentage}%`
  };
  return (
    <div className="stars">
      <div className="empty-stars">
        <FiveStars/>
      </div>
      <div className="full-stars" style={style}>
        <FiveStars/>
      </div>
    </div>
  );
}

function FiveStars() {
  return (
    <>
      <Star/><Star/><Star/><Star/><Star/>
    </>
  );
}

function Statistics({ rating, reviewCount }) {
  return (
    <div className="statistics">
      <span className="rating">{rating}</span>
      <span className="review-count">({reviewCount} {pluralize(reviewCount, 'rating')})</span>
    </div>
  );
}

function getGoogleReviewData(reviews) {
  const aggregates       = reviews?.aggregates ?? [];
  const googleReviewData = aggregates.find(({ service }) => service === 'google');
  return googleReviewData;
}


function Actions({ complete }) {
  return (
    <div className="actions">
      <button className="button button-fill confirm-location-button" onClick={complete}>
        <MapPin/>
        <span className="label">Confirm location</span>
      </button>
    </div>
  );
}
